module.exports = __webpack_public_path__ + "static/media/channel-walle.cdb3caf1.svg";